// Sincroniza el <head> con la ruta en la navegación del lado del cliente. El prerender escribe el <head>
// de la primera carga; sin esto, al ir de /precios a /terminos el título y el canonical se quedarían con
// los de la primera página. Misma fuente que el prerender: PUBLIC_ROUTE_META (src/seo/routeMeta.js).
import { NOT_FOUND_META, resolveRouteMeta } from "./routeMeta";

const FIELDS = [
  ['meta[name="description"]', "content", "description"],
  ['link[rel="canonical"]', "href", "url"],
  ['meta[property="og:title"]', "content", "title"],
  ['meta[property="og:description"]', "content", "description"],
  ['meta[property="og:url"]', "content", "url"],
  ['meta[name="twitter:title"]', "content", "title"],
  ['meta[name="twitter:description"]', "content", "description"],
];

export function applyRouteMeta(doc, pathname) {
  const meta = resolveRouteMeta(pathname);
  doc.title = meta.title;
  for (const [selector, attr, key] of FIELDS) {
    doc.head.querySelector(selector)?.setAttribute(attr, meta[key]);
  }
  return meta;
}

/**
 * Cabeza de una página 404 en el cliente: título, descripción y `noindex`. Devuelve la limpieza, que quita el
 * `noindex` al salir de la 404: sin ella, navegar a /precios dejaría esa página marcada como no indexable.
 */
export function applyNotFoundMeta(doc) {
  doc.title = NOT_FOUND_META.title;
  doc.head.querySelector('meta[name="description"]')?.setAttribute("content", NOT_FOUND_META.description);
  let robots = doc.head.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = doc.createElement("meta");
    robots.setAttribute("name", "robots");
    doc.head.appendChild(robots);
  }
  robots.setAttribute("content", "noindex");
  return () => doc.head.querySelector('meta[name="robots"]')?.remove();
}
